export default [
  { card: 'visa', type: 'Visa', icon: '/icons/visa.svg' },
  { card: 'mastercard', type: 'Master Card', icon: '/icons/master_card.svg' },
  { card: 'amex', type: 'American Express', icon: '/icons/amex.svg' },
];
